import { Colors } from '@oy/uicore';
import type { ChartOptions } from 'chart.js';

export const defaultPluginsOption: ChartOptions['plugins'] = {
  legend: { position: 'bottom', labels: { padding: 20 } },
  tooltip: {
    backgroundColor: Colors.WHITE,
    titleColor: Colors.BLACK200,
    bodyColor: Colors.BLACK100,
    borderColor: Colors.BLACK5,
    borderWidth: 0.5,
    boxWidth: 18,
    padding: 16,
    bodySpacing: 4,
    callbacks: {
      labelColor: item => ({
        backgroundColor:
          typeof item.dataset.borderColor === 'string'
            ? item.dataset.borderColor
            : Array.isArray(item.dataset.backgroundColor)
            ? item.dataset.backgroundColor[item.dataIndex]
            : typeof item.dataset.backgroundColor === 'string'
            ? item.dataset.backgroundColor
            : '#fff',
        borderColor: 'transparent',
        borderWidth: 0,
      }),
    },
  },
};
